module.exports = __webpack_public_path__ + "static/media/trieste-22.bf73e437.jpg";